import { useContext, useState } from 'react'
import { AppContext } from '../../../contextApi/ContextApi';
import { DashboardContext } from '../../../contextApi/DashboardContext';

export default function JobCard({website, job}) {
    const {primary_color, accent_color, secondary_color, setToastMessage, messagesOptions} = useContext(AppContext);
    const {handleDeleteItem} = useContext(DashboardContext);
    const [descFlag, setDescFlag] = useState(false);

    const deployList =(list)=>{
        if (!list) return<p>אין</p>;
        return list?.map((item, inx)=>{
            return <li key={`jobList_dashboard_${item}_${inx}`}className='jobList_dashboard_descLine' >{item}</li>
        })
    }

    return (
        <div className='jobCard_dashboard' style={{backgroundColor:primary_color, color:accent_color, textShadow:`1px 1px 2px ${secondary_color}`}}>
            <div className='jobCard_dashboard_header'>
                <div onClick={()=>{handleDeleteItem(website.id, "settings.jobs", job, setToastMessage, messagesOptions)}}>x</div>
                <div>{job.title}</div>
                <div onClick={()=>{setDescFlag(!descFlag)}}>▼</div>
            </div>
            {descFlag && <div className='jobCard_dashboard_desc'>
                <div className='jobCard_dashboard_desc_subDiv'>
                    <h3>תיאור כללי</h3>
                    {job.details}
                </div>
                <div className='jobCard_dashboard_desc_subDiv'>
                    <h3>דרישות משרה</h3>
                    {deployList(job?.requirements)}
                </div>
                <div className='jobCard_dashboard_desc_subDiv'>
                    <h3>יתרונות תפקיד</h3>
                    {deployList(job?.benefits)}
                </div>
            </div>}
        </div>
    )
}
